const Slider = require('react-slick').default;
const DefaultSetting = {
    dots: true,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    color: '#33ecfe'
};

export default function Slide({setting = {}, getRef, children}) {
    return (
        <Slider {...{...DefaultSetting, ...setting}} ref={slider => {
            if(getRef) {
                getRef(slider);
            }
        }}>
            {children}
        </Slider>
    );
}